import { useEffect, useState } from 'react';
import { ApiHostPrefix, ApiService } from '@/services/ApiService';

export function useApiHostPrefix(): ApiHostPrefix {
  const [prefix, setPrefix] = useState<ApiHostPrefix>(() => ApiService.getApiHostPrefix());

  useEffect(() => {
    return ApiService.subscribeHostPrefix(() => {
      setPrefix(ApiService.getApiHostPrefix());
    });
  }, []);

  return prefix;
}

export function useIsStagingApi(): boolean {
  return useApiHostPrefix() === 'staging';
}
